/*global $ */
/* eslint-disable react-intl/string-is-marked-for-translation */
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import jQuery from 'jquery';

// Need jQuery in global space for foundation and ScrollMagic/gsap
window.jQuery = jQuery;
window.$ = jQuery;
window.hashTrack = true;
window.globalScene = [];
window.allTweens = [];

if (typeof document !== 'undefined') {
  // Binds Foundation to window
  require('foundation-sites-5');
  require('foundation-sites-5/js/foundation/foundation.topbar');

  window.classie = require('desandro-classie/classie') || null;
  window.Snap = require('imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js');
  //SVGLoader requires classie and Snap libs
  require('helpers/svgLoader');

  require('slick-carousel');
}

import { createElement, PropTypes } from 'rlink-react';
import getCurrentRouteState from 'rlink-router/getCurrentRouteState';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';
import RoutingComponent from 'rlink-router/component';
import { mergeStaticOptions } from 'rlink-utils/object';
import themeable from 'rlink-theme/themeable';
import GdprCookieConsent from 'rlink-cookies/components/GdprCookieConsent';

import ScrollMagic from 'helpers/importers/ScrollMagic';
import onKeyPressScrollTo from 'helpers/scrolling/onKeyPressScrollTo';
import initScroll from 'helpers/scrolling/initScroll';
import preloader from 'helpers/preloader';
import clearHash from 'helpers/clearHash';
import updateGlobalScenes from 'helpers/scenes/updateGlobalScenes';

import MainTheme from 'theme/Main.less';
import GdprCookieConsentTheme from 'theme/rlink-cookies/GdprCookieConsent.less';
import 'theme/legacy.less';

class Main extends RoutingComponent {
  start () {
    initScroll(this.cacheHash);
  }

  checkElements (_func) {
    if ($('#franchises').length
        && $('#studio').length
        && $('#pictures').length
        && $('#slider').length
        && $('#history').length) {
      this.start();
    } else {
      setTimeout(this.checkElements, 1000);
    }
  }

  init () {
    if ($('body:not(.scroller-processed)').length > 0) {
      $('body').addClass('scroller-processed');

      if ($('body.front').length > 0) {

        $(document).keydown(e => onKeyPressScrollTo(e));

        $(window).on('hashchange', e => {
          e.preventDefault();
        });

        this.cacheHash = clearHash();
        $('html,body').scrollTop(0);

        $(window).on('pageready', () => {
          this.checkElements();
        });

        this.preloader = new preloader();
      } else {
        $('body').removeClass('loading');
        $('.load').remove();
        $('#master').removeAttr('style');
      }
    }
  }

  updateGdprConsentState (hasConsented) {
    this.setState({GdprConsent: hasConsented});
  }

  componentDidUpdate () {
    if (!window.controller.enabled()) {
      window.controller.enabled(true);
      updateGlobalScenes();
    }
  }

  componentWillMount () {
    if (ScrollMagic) {
      window.controller = new ScrollMagic.Controller({
        loglevel: 0,
        addIndicators: false,
      });
    }
  }

  componentDidMount () {
    if (typeof document !== 'undefined') {
      this.init();
      window.Foundation.init();
      //Picture tag polyfill for older safari versions (iPhone 6/5 support)
      require('picturefill');
      document.createElement( 'picture' );

      document.body.classList.add('no-touch');
      window.addEventListener('touchstart', () => {
        document.body.classList.remove('no-touch');
        document.body.classList.add('touch');
        window.removeEventListener('touchstart', null, false);
      });
    }
  }

  render () {
    let {theme, bare} = this.props;
    if (bare) {
      return (
        <div>
          <GdprCookieConsent
            theme={GdprCookieConsentTheme}
            onAccept={() => this.updateGdprConsentState(true)} />
          {this.viewContent()}
        </div>
      );
    }
    return (
      <div className={`${theme.LayoutContainer}`}>
        <GdprCookieConsent
          theme={GdprCookieConsentTheme}
          onAccept={() => this.updateGdprConsentState(true)} />
        {this.viewContent()}
      </div>
    );
  }
}

Main.propTypes = {
  bare: PropTypes.bool,
  currentView: PropTypes.string,
};

mergeStaticOptions(Main, {
  defaultProps: {
    theme: MainTheme,
  },
});

themeable(Main, {
  classes: [
    'LayoutContainer',
  ],
});

function mapStateToProps ({routing}) {
  let {view} = getCurrentRouteState(routing);
  return {currentView: view};
}

export default compose(
  injectIntl,
  connect(mapStateToProps),
  connectToPathForContent
)(Main);



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Main.jsx